import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function DetailsButton({ rowId }) {
  const navigate = useNavigate();

  const handlerClick = () => {
    navigate(`/details/${rowId}`);
  };

  return (
    <Button variant='contained' color='success' size='small' onClick={handlerClick}>
      Detalhes
    </Button>
  );
}

function renderStatus(status) {
  const normalized = String(status || '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/\s+/g, '_');

  if (normalized === 'ANALYSIS' || normalized === 'EM_ANALISE') {
    return <Chip label='Em Análise' color='warning' size='small' />;
  }

  if (normalized === 'WAITING_ANALYSIS' || normalized === 'AGUARDANDO_ANALISE') {
    return <Chip label='Aguardando Análise' color='warning' size='small' />;
  }

  if (normalized === 'FINALIZED' || normalized === 'FINALIZADO' || normalized === 'FINALIZADA') {
    return <Chip label='Finalizado' color='success' size='small' />;
  }

  if (normalized === 'REPORT' || normalized === 'REPORTED' || normalized === 'REPORTADO' || normalized === 'REPORTADA') {
    return <Chip label='Reportado' color='error' size='small' />;
  }

  return <Chip label={status} color='default' size='small' />;
}

export function renderAvatar(params) {
  if (params.value == null)
    return '';

  return (
    <Avatar
      sx={{
        backgroundColor: params.value.color,
        width: '24px',
        height: '24px',
        fontSize: '0.85rem',
      }}
    >
      {params.value.name.toUpperCase().substring(0, 1)}
    </Avatar>
  );
}

export const columns = [
  {
    field: 'id',
    headerName: 'ID Transação',
    flex: 1.5,
    minWidth: 200,
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    minWidth: 190,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => renderStatus(params.value),
  },
  {
    field: 'transactionType',
    headerName: 'Tipo de Transação',
    flex: 1,
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'value',
    headerName: 'Valor Transação',
    headerAlign: 'center',
    align: 'center',
    flex: 1,
    minWidth: 80,
  },
  {
    field: 'eventCount',
    headerName: 'Apontamentos',
    headerAlign: 'center',
    align: 'center',
    flex: 1,
    minWidth: 100,
    renderCell: (params) => {
      const count = params.value || 0;
      const appointments = params.row.appointments || [];

      if (count === 0)
        return '0';

      return (
        <Chip
          label={count}
          color='error'
          size='small'
          title={appointments.length > 0 ? appointments.join(', ') : 'Alertas detectados'}
        />
      );
    },
  },
  {
    field: 'dateHourTransaction',
    headerName: 'Data/Hora',
    headerAlign: 'center',
    align: 'center',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'actions',
    headerName: 'Detalhes',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    renderCell: (params) => <DetailsButton rowId={params.row.id} />,
  },
];
